<div class="row">
  <div class="row text-center mt-3">
    <div class="fs-2 fw-bold col-md-12 my-3">
      {{ "imakeapp system" | translate }}
    </div>
    <div class="fs-5 fw-bold col-md-12 my-1">
      {{ "Comprehensive school management program" | translate }}
    </div>
    <div class="col-md-12 fw-bold mt-4">
      <a href="https://madaresfront.codesroots.com/" target="_blank">
        <button class="btn try-it-btn fw-bold px-5">
          {{ "Try It Now" | translate }}
        </button>
      </a>
    </div>
    <div class="my-3 col-md-12">
      <span class="fs-6">{{
        "username: safa | password: 123456" | translate
      }}</span>
    </div>
  </div>
  <div class="row text-center mt-5">
    <div class="col-md-12 mb-3">
      <img
        src="../../assets/images/Free iMac Mockup With Two Different Perspective.png"
        alt=""
      />
    </div>
    <div class="col-md-12 mt-5">
      <p class="fs-4 fw-bold">
        {{ "The most important feature of the program" | translate }}
      </p>
    </div>
  </div>
  <!-- first section  -->
  <div class="row mt-5 report_section pt-5">
    <div class="col-md-6 mt-3 text-center report_section_header">
      <div class="col-md-8 text-right m-auto">
        <h2 class="fw-bold">{{ "Comprehensive reports" | translate }}</h2>
        <ul class="report_list fw-bold rports_text">
          <li>
            {{ "Report of expenses that are about to be paid" | translate }}
          </li>
          <li>
            {{ "Report of complaints of parents" | translate }}
          </li>
          <li>
            {{
              "A report of students who are late for paying tuition" | translate
            }}
          </li>
          <li>
            {{
              "A report on tuition fees and annual school revenues" | translate
            }}
          </li>
          <li>
            {{
              "Reports of the students in the school, all their information, and the ability to filter them"
                | translate
            }}
          </li>

          <li>
            {{
              "A report on the monthly and annual expenses of the school"
                | translate
            }}
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-6 mb-3 text-center report_section_header_2">
      <img
        src="../../assets/images/Device-2@2x.png"
        alt=""
        width="100%"
        height="100%"
      />
    </div>
  </div>
  <!-- second section  -->
  <div class="row pt-5">
    <div class="col-md-6 mb-3 text-center">
      <img
        src="../../assets/images/27 iMac@2x.png"
        alt=""
        width="100%"
        height="100%"
      />
    </div>
    <div class="col-md-6 mt-3 text-center report_section_header">
      <div class="col-md-12 text-right">
        <h2 class="fw-bold">
          {{ "School student management department" | translate }}
        </h2>
        <p class="report_list fw-bold rports_text">
          {{
            "The school management system allows you to add all the students of the school, specify their attendance and absence days, and filter the student according to the academic stage and academic division."
              | translate
          }}
        </p>
        <h2 class="fw-bold">
          {{ "Parents" | translate }}
        </h2>
        <p class="report_list fw-bold rports_text">
          {{
            "The possibility of adding parents and linking them with more than one student, the possibility of making a complaint by the guardian and receiving notifications from the school"
              | translate
          }}
        </p>
      </div>
    </div>
  </div>
  <!-- third section  -->
  <div class="row report_section pt-5">
    <div class="col-md-6 mt-3 text-center report_section_header">
      <div class="col-md-12 text-right">
        <h2 class="fw-bold">
          {{ "School expense management" | translate }}
        </h2>
        <p class="report_list fw-bold rports_text">
          {{
            "Through your schools system, you can add all your products and types of expenses for the school, make reports for them, and add suppliers for the school"
              | translate
          }}
        </p>
        <h2 class="fw-bold">
          {{ "School revenue and expenses management" | translate }}
        </h2>
        <p class="report_list fw-bold rports_text">
          {{
            "Your schools system enables you to record the expenses of each student and the remaining ones, and notify the guardian of his late expenses and the possibility of viewing them, as well as making reports on school revenues"
              | translate
          }}
        </p>
      </div>
    </div>
    <div class="col-md-6 mb-3 text-center">
      <img
        src="../../assets/images/macbook air@2x.png"
        alt=""
        width="100%"
        height="100%"
      />
    </div>
  </div>
  <!-- fourth section  -->
  <div class="row pt-5">
    <div class="col-md-6 mb-3 text-center">
      <img
        src="../../assets/images/Device@2x.png"
        alt=""
        width="100%"
        height="100%"
      />
    </div>
    <div class="col-md-6 mt-3 text-center report_section_header">
      <div class="col-md-12 text-right">
        <h2 class="fw-bold">
          {{ "Managing events, notices and complaints" | translate }}
        </h2>
        <p class="report_list fw-bold rports_text">
          {{
            "Through the site, you can enable your school system to add school events and send notifications to parents to attend events such as Mother's Day or summon the guardian by adding a car rental contract so that the legal procedures are completed and the contract is valid for that traffic in addition to direct access to the system"
              | translate
          }}
        </p>
        <h2 class="fw-bold">
          {{ "Management of grades and exams" | translate }}
        </h2>
        <p class="report_list fw-bold rports_text">
          {{
            "Through the system, you can control all student grades and exams and their types within the school, and identify successful and failed students"
              | translate
          }}
        </p>
      </div>
    </div>
  </div>
  <!-- Fifth section  -->
  <div class="row report_section pt-5">
    <div class="col-md-6 mt-3 text-center report_section_header">
      <div class="col-md-12 text-right">
        <h2 class="fw-bold">
          {{ "Comprehensive control panel" | translate }}
        </h2>
        <p class="report_list fw-bold rports_text">
          {{
            "An unintended error occurred from one of your employees, and you want to correct it, it is very easy. Take a look at the program settings in the trial program"
              | translate
          }}
        </p>
        <h2 class="fw-bold">
          {{ "Multilanguage" | translate }}
        </h2>
        <p class="report_list fw-bold rports_text">
          {{
            "There is no need to worry anymore about the inability to master the languages of the programs, as we would like to be fully aware that one of the priorities of our programs is to help the customer as much as possible to amend them whenever needed to finish his work and arrange it smoothly and solve all the technical obstacles that prevent him from working on our programs, for this we have Adding the feature of multilingualism"
              | translate
          }}
        </p>
      </div>
    </div>
    <div class="col-md-6 mb-3 text-center">
      <img
        src="../../assets/images/macbook air-2@2x.png"
        alt=""
        width="100%"
        height="100%"
      />
    </div>
  </div>

  <!-- <app-packages [packages]="packages"></app-packages> -->

  <div class="py-5"></div>
</div>
